import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import settings from "settings"
import { loadingStatus } from "actions"
import axios from "axios"
import LotModal from "containers/modals/lot"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import PressingTable from "widgets/pressingTable"

const BadData = () => {
	const dispatch = useDispatch()
	const currentDates = useSelector((state) => state.currentDates)
	const compareDates = useSelector((state) => state.compareDates)
	const payload = useSelector((state) => state.payload)
	const payloadStatus = useSelector((state) => state.payloadStatus)
	const activeProperties = useSelector((state) => state.activeProperties)

	const [columns, setColumns] = useState({
		missingSales: [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Buyer Status",
				accessor: "lot_status",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_status"),
			},
			{
				Header: "Buyer Last Name",
				accessor: "primary_last",
				filterMethod: (f, r) => helpers.tableText(f, r, "primary_last"),
			},
			{
				Header: "Sale Date",
				accessor: "sale_date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.tableText(f, r, "sale_date"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Model",
				accessor: "model",
				filterMethod: (f, r) => helpers.tableText(f, r, "model"),
			},
			{
				Header: "Complete Date",
				accessor: "complete_date",
				filterMethod: (f, r) => helpers.tableText(f, r, "complete_date"),
				Cell: (v) => moment.unix(v.value).format("MM/DD/YY"),
			},
			{
				Header: "View",
				accessor: "view",
			},
		],
		missingClosings: [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Buyer Last Name",
				accessor: "primary_last",
				filterMethod: (f, r) => helpers.tableText(f, r, "primary_last"),
			},
			{
				Header: "Sale Date",
				accessor: "sale_date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.tableText(f, r, "sale_date"),
			},
			{
				Header: "Estimated Closing",
				accessor: "estimated_closing",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.tableText(f, r, "estimated_closing"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Salesperson",
				accessor: "salesperson",
				filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
			},
			{
				Header: "Model",
				accessor: "model",
				filterMethod: (f, r) => helpers.tableText(f, r, "model"),
			},
			{
				Header: "View",
				accessor: "view",
			},
		],
		missingARCApproval: [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Lot Status",
				accessor: "lot_status",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_status"),
			},
			{
				Header: "Start Date",
				accessor: "start_date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.tableText(f, r, "start_date"),
			},
		],
		badConstructionStatus: [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Takedown Date",
				accessor: "takedown_date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
			},
			{
				Header: "Start Date",
				accessor: "start_date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.tableText(f, r, "start_date"),
			},
			{
				Header: "Complete Date",
				accessor: "complete_date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.tableText(f, r, "complete_date"),
			},
		],
		missingMarketingInfo: [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Start Date",
				accessor: "start_date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.tableText(f, r, "start_date"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Missing Data",
				accessor: "badString",
				filterMethod: (f, r) => helpers.tableText(f, r, "badString"),
			},
			{
				Header: "Sales Reps",
				accessor: "salesReps",
				filterMethod: (f, r) => helpers.tableText(f, r, "salesReps"),
			},
			{
				Header: "View",
				accessor: "view",
			},
		],
		missingMarketingFloorplanInfo: [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Name",
				accessor: "name",
				filterMethod: (f, r) => helpers.tableText(f, r, "name"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Missing Data",
				accessor: "badString",
				filterMethod: (f, r) => helpers.tableText(f, r, "badString"),
			},
			{
				Header: "View",
				accessor: "view",
			},
		],
		missingConstructionStatus: [
			{
				Header: "Community",
				accessor: "community",
				filterMethod: (f, r) => helpers.tableText(f, r, "community"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Takedown Date",
				accessor: "takedown_date",
				Cell: (v) => (v.value ? moment.unix(v.value).format("MM/DD/YY") : ""),
				filterMethod: (f, r) => helpers.tableText(f, r, "takedown_date"),
			},
			{
				Header: "Issue",
				accessor: "issue",
				filterMethod: (f, r) => helpers.tableText(f, r, "issue"),
			},
		],
	})

	const [sorted, setSorted] = useState({
		missingSales: [],
		missingClosings: [],
	})

	const [data, setData] = useState({})
	const [lotID, setLotID] = useState(false)
	const [open, setOpen] = useState(false)

	useEffect(() => {
		getData()
	}, [currentDates, activeProperties])

	const getData = () => {
		dispatch(loadingStatus(true))
		let userToken = localStorage.getItem("user")
		axios
			.post(
				settings.ep + "/getBadData",
				{
					properties: activeProperties,
				},
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
			.then((resp) => {
				if (resp.data.status === 400) {
					setData([])
					dispatch(loadingStatus(false))
				} else if (resp.status === 200) {
					setData(resp.data.data)
					dispatch(loadingStatus(false))
				} else {
					setData([])
					dispatch(loadingStatus(false))
				}
			})
	}

	const missingSales = () => {
		let ret = []
		_.forEach(data.missingSales, (v) => {
			let community = _.find(payload.public.properties, { id: v.property })
			let builder = _.find(payload.public.builders, { id: v.builder })
			v.lot_id = v.id
			ret.push({
				community: community ? community.name : "",
				address: v.address,
				complete_date: v.complete_date,
				builder: builder ? builder.name : "",
				model: v.model === 1 ? "Yes" : "No",
				primary_last: v.primary_last,
				sale_date: v.sale_date,
				lot_status: v.lot_status,
				view: (
					<a onClick={() => openModal(v)}>
						<i className="far fa-edit"></i>
					</a>
				),
			})
		})
		return ret
	}

	const missingClosings = () => {
		let ret = []
		_.forEach(data.missingClosings, (v) => {
			let community = _.find(payload.public.properties, { id: v.property })
			let builder = _.find(payload.public.builders, { id: v.builder })
			let salesperson = _.find(payload.public.salespeople, { id: v.salesperson })
			ret.push({
				community: community ? community.name : "",
				address: v.address,
				builder: builder ? builder.name : "",
				model: v.model === 1 ? "Yes" : "No",
				primary_last: v.primary_last,
				sale_date: v.sale_date,
				estimated_closing: v.estimated_closing,
				lot_status: v.lot_status,
				salesperson: salesperson ? `${salesperson.first} ${salesperson.last}` : "",
				view: (
					<a onClick={() => openModal(v)}>
						<i className="far fa-edit"></i>
					</a>
				),
			})
		})
		return ret
	}

	const missingMarketingInfo = () => {
		let ret = []
		_.forEach(data.missingMarketingInfo, (v) => {
			let community = _.find(payload.public.properties, { id: v.property })
			let builder = _.find(payload.public.builders, { id: v.builder })
			ret.push({
				community: community ? community.name : "",
				address: v.address,
				builder: builder ? builder.name : "",
				lot_status: v.lot_status,
				salesReps: v.salesReps || "",
				badString: v.badString || "",
				start_date: v.start_date,
				view: (
					<a onClick={() => openModal(v)}>
						<i className="far fa-edit"></i>
					</a>
				),
			})
		})
		return ret
	}

	const missingMarketingFloorplanInfo = () => {
		let ret = []
		_.forEach(payload?.public.floorplans, (v) => {
			// Skip floorplans that don't belong to active properties
			if (!_.intersection(v.properties, activeProperties).length) {
				return
			}
			let community = _.find(payload.public.properties, { id: activeProperties[0] })
			let builder = _.find(payload.public.builders, { id: v.builder })
			let badString = ""
			if (!v.price) badString += "Price, " // should this be base price by community?  no time now
			if (!v.beds) badString += "Beds, "
			if (!v.full_baths) badString += "Baths, "
			if (!v.sqft) badString += "Sqft, "
			if (!v.images || v.images.length === 0) badString += "Images, "
			badString = badString.slice(0, -2)
			if (badString === "") return
			ret.push({
				community: community ? community.name : "",
				name: v.name,
				builder: builder ? builder.name : "",
				lot_status: v.lot_status,
				badString,
			})
		})
		return ret
	}

	const missingConstructionStatus = () => {
		let ret = []
		_.forEach(data.missingConstruction, (v) => {
			let community = _.find(payload.public.properties, { id: v.property })
			let builder = _.find(payload.public.builders, { id: v.builder })
			let issue
			if (v.missing_start) issue = "Missing Start Date"
			else if (v.missing_complete) issue = "Missing Complete Date"
			ret.push({
				community: community ? community.name : "",
				address: v.address,
				builder: builder ? builder.name : "",
				takedown_date: v.takedown_date,
				issue,
			})
		})
		return ret
	}

	const badConstructionStatus = () => {
		let ret = []
		_.forEach(payload.exec.lots, (v) => {
			if (
				(v.start_date && !v.takedown_date) ||
				(v.complete_date && !v.start_date) ||
				(v.complete_date && !v.takedown_date) ||
				(v.complete_date &&
					v.start_date &&
					moment.unix(v.complete_date).diff(moment.unix(v.start_date), "days") < 60)
			) {
				let community = _.find(payload.public.properties, { id: v.property })
				let builder = _.find(payload.public.builders, { id: v.builder })
				ret.push({
					community: community ? community.name : "",
					address: v.address,
					builder: builder ? builder.name : "",
					takedown_date: v.takedown_date,
					start_date: v.start_date,
					complete_date: v.complete_date,
					view: (
						<a onClick={() => openModal(v)}>
							<i className="far fa-edit"></i>
						</a>
					),
				})
			}
		})
		return ret
	}

	const missingARCApproval = () => {
		let ret = []
		_.forEach(data.missingARCApproval, (v) => {
			let community = _.find(payload.public.properties, { id: v.property })
			let builder = _.find(payload.public.builders, { id: v.builder })
			ret.push({
				community: community ? community.name : "",
				address: v.address,
				builder: builder ? builder.name : "",
				lot_status: v.lot_status,
				start_date: v.start_date,
			})
		})
		return ret
	}

	const closeModal = () => {
		setOpen(false)
	}

	const openModal = (v) => {
		setLotID({ id: v.lot_id, property: v.property })
		setOpen(true)
	}

	if (payloadStatus) {
		return (
			<div className="inventory">
				<div className="imageGroup">
					<Title title="Missing Data Report" showDate={false} />
					<div className="content">
						<PressingTable mode="developer" data={data} />
					</div>
					<div className="content inventory__content">
						<h2>Completed Homes Missing Sales or Closings</h2>
						<p className="small pt-4">
							All lots with completion dates one year ago or older without closing dates.
						</p>
						<FullTable
							data={missingSales()}
							columns={columns.missingSales}
							name="badData__missingSales"
							title="Missing Sales"
							unset={["view"]}
							classNames={"small"}
						/>
					</div>
				</div>
				<div className="imageGroup">
					<div className="content inventory__content">
						<h2>Missing Marketing Spec Information for Website</h2>
						<p className="small pt-4">
							Homes completed or under construction that do not have required marketing information:
							price, beds, baths, sqft, or imagery.
						</p>
						<FullTable
							data={missingMarketingInfo()}
							columns={columns.missingMarketingInfo}
							name="missingMarketingInfo"
							title="Missing Marketing Info"
							unset={["view"]}
							classNames={"small"}
						/>
					</div>
					<div className="content inventory__content">
						<h2>Missing Marketing Floorplan Information for Website</h2>
						<p className="small pt-4">
							Plans completed or under construction that do not have required marketing information:
							price, beds, baths, sqft, or imagery.
						</p>
						<FullTable
							data={missingMarketingFloorplanInfo()}
							columns={columns.missingMarketingFloorplanInfo}
							name="missingMarketingFloorplanInfo"
							title="Missing Marketing Floorplan Info"
							unset={["view"]}
							classNames={"small"}
						/>
					</div>
				</div>
				<div className="imageGroup">
					<div className="content inventory__content">
						<h2>Missing Closings or Cancels</h2>
						<p className="small pt-4">
							All active sales that are two months beyond their estimated closing date.
						</p>
						<FullTable
							data={missingClosings()}
							columns={columns.missingClosings}
							name="badData__missingClsings"
							title="Missing Closings"
							unset={["view"]}
							classNames={"small"}
						/>
						<h2>Missing Construction Status</h2>
						<p className="small pt-4">Lots that have been found to be missing a start or complete date.</p>
						<FullTable
							data={missingConstructionStatus()}
							columns={columns.missingConstructionStatus}
							name="badData__missingConstruction"
							title="Missing Construction Status"
							unset={["view"]}
							classNames={"small"}
						/>
						<h2>Bad Construction Status</h2>
						<p className="small pt-4">
							Lots that have improper construction statuses, e.g. a lot with a complete date with no start
							date, or lots with a complete date less than 60 days from the start date.
						</p>
						<FullTable
							data={badConstructionStatus()}
							columns={columns.badConstructionStatus}
							name="badData__badConstructionStatus"
							title="Bad Construction Status"
							unset={["view"]}
							classNames={"small"}
						/>
					</div>
				</div>
				{settings.arc && (
					<div className="imageGroup">
						<div className="content inventory__content">
							<h2>Missing ARC Approval</h2>
							<p className="small pt-4">
								Lots with a start date but do not have conditional or full approval.
							</p>
							<FullTable
								data={missingARCApproval()}
								columns={columns.missingARCApproval}
								name="badData__missingARCApproval"
								title="Missing ARC Approval"
								unset={["view"]}
							/>
						</div>
					</div>
				)}
				<LotModal open={open} data={lotID} onClose={closeModal} />
			</div>
		)
	} else {
		return null
	}
}

export default BadData
